import React, { useEffect, useState } from 'react';
import {
    ActionItemCombinedProps,
    ActionItemContent,
} from '../../../models/experiencefragments/action-item';
import '../../common/fm-action-item/fm-action-item.scss';
import FMActionItem from '../../common/fm-action-item/fm-action-item';
import { transformToActionItemContent } from './fm-service-reminder-util';
import useUserProfile from '../../../hooks/use-user-profile';

const FMActionItemServiceReminder = (props: ActionItemCombinedProps) => {
    const {
        apiData,
        content,
        requiredLabel,
        recommendedLabel,
        ...restProps
    } = props;
    const [uomDistance, setUomDistance] = useState<number>(0);
    const profile = useUserProfile();

    useEffect(() => {
        if (profile) {
            if (profile.profile) {
                setUomDistance(profile.profile.uomDistance);
            }
        }
    }, [profile]);

    // Ensure content is always of type ActionItemContent
    const serviceReminderContent: ActionItemContent = transformToActionItemContent(
        apiData,
        content,
        uomDistance
    );
    return (
        <FMActionItem
            required={true}
            content={serviceReminderContent}
            requiredLabel={requiredLabel}
            recommendedLabel={recommendedLabel}
            {...restProps}
        />
    );
};

export default FMActionItemServiceReminder;
